import VinLookupService from './services/VinLookupService';
import VehicleImageLookupService from './services/VehicleImageLookupService';
import AvailabilityService from './services/AvailabilityService';
import CoverageService from './services/CoverageService';
import 'portalConfig';
import 'edge/platform/base/module';

export default angular.module('edge.policyjob.app', ['portal.config', 'edge.platform.base']).config(['EventHubProvider', function (EventHubProvider) {
    EventHubProvider.registerTransformer({
        source: {
            category: 'tracking',
            eventName: 'serverCall'
        },
        target: {
            category: 'journey',
            eventName: 'policyChange'
        },
        transformer: function transformer(payload, send) {
            if (payload && payload.success && payload.path && payload.method === 'bind' && payload.path === 'policychange/policychange') {
                var policyChange = payload.response.policyChange;
                if (policyChange.status === 'Bound') {
                    send({
                        accountNumber: policyChange.accountNumber,
                        policyNumber: policyChange.policyNumber,
                        productCode: policyChange.productCode,
                        effectiveDate: policyChange.effectiveDate,
                        jobID: policyChange.jobID,
                        history: policyChange.history
                    });
                }
            }
        }
    });
    EventHubProvider.registerTransformer({
        source: {
            category: 'wizard',
            eventName: '*'
        },
        target: {
            category: 'tracking',
            eventName: 'pageView'
        },
        transformer: function transformer(payload, send) {
            if (payload && (payload.url === '/endorsement' || payload.url === '/endorsement') && payload.model && payload.model.policyChange && payload.model.policyChange.productCode && payload.toState) {
                var url = payload.url;
                var wizardStepName = payload.toState.name;
                var productCode = payload.model.policyChange.productCode;
                send({
                    path: url + '/' + productCode + '/' + wizardStepName
                });
            }
        }
    });
}]).value('policyjob.endpointConfig', {
    'vinlookup': 'vehicleinfo/lookup',
    'availability': 'availability'
}).value('policyjob.xCenterRouteConfig', 'quote').factory('VinLookupService', VinLookupService).factory('VehicleImageLookupService', VehicleImageLookupService).factory('AvailabilityService', AvailabilityService).factory('CoverageService', CoverageService);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policyjob/app.js
// module id = 84
// module chunks = 0